<div class="flex-display height-100per">
  <div class="float-L width-86 view-height-overflow">
    <div class="pr-96px pr-1-25 pt-3">
      <div class="pcform pr-1-25 pt-0">
        <h1 class="top-heading content-blue" tabindex="0">{{header}}</h1>
        <p class="answer font-16 content-blue width-100" tabindex="0">{{body}}</p>
        <h2 class="topic-heading font-16 content-blue bold" tabindex="0">{{subHeading1}}</h2>
        <p class="answer font-16 content-blue width-100" tabindex="0">{{subBody1}}</p>
        <div class="bold font-14 mb-2" id="AboutUsingLink" role="heading" aria-level="2" tabindex="0">
          <a target="_blank" href="{{subLink1}}">{{subLinkText1}}</a>
        </div>
        <h2 class="topic-heading font-16 content-blue bold" tabindex="0">{{subHeading2}}</h2>
        <p class="answer font-16 content-blue width-100" tabindex="0">{{subBody2}}</p>
        <div class="bold font-14" id="CopyrightLink" role="heading" aria-level="2" tabindex="0">
          <a target="_blank" href="{{subLink2}}">{{subLinkText2}}</a>
        </div>
        <br />
        <hr class="border-top-gray pb-24px">

        <div *ngFor="let statement of statements1">
          <div class="para mb-0-2">
            <span class="content">
              <span [innerHTML]="statement.label1"></span>
              <br>
              <span [innerHTML]="statement.label2"></span>
              <br>
              <span [innerHTML]="statement.label3"></span>
              <br>
            </span>
            <span class="answer mr-0-4" *ngFor="let pdf of statement?.pdflink">
              <a class="pdf-link" id="{{pdf?.pdffile?.title}}" (contextmenu)="onRightClick($event)" (click)="openLinkById($event)" [innerHTML]="pdf?.linkText"></a>
            </span>
            <span class="answer mr-0-4" *ngFor="let link of statement?.externalLink">
              <a class="external-fasb-link" id="{{baseFasbLink+link?.externalLink}}" (contextmenu)="onRightClick($event)" (click)="openLinkById($event)" [innerHTML]="link?.linkText"></a>
            </span>
            <div class="mt-0-2" [innerHTML]="statement.label4"></div>
            <br>
          </div>
        </div>

        <div class="mb-1-5">
          <h2 class="topic-heading font-16 content-blue bold" tabindex="0" [innerHTML]="subHeading3"></h2>
        </div>
        
        <div *ngFor="let statement of statements2">
          <div class="para mb-0-2">
            <span class="content">
              <span [innerHTML]="statement.label1"></span>
              <br>
              <span [innerHTML]="statement.label2"></span>
              <br>
              <span [innerHTML]="statement.label3"></span>
              <br>
            </span>
            <span class="answer mr-0-4" *ngFor="let pdf of statement?.pdflink">
              <a class="pdf-link" id="{{pdf?.pdffile?.title}}" name="{{pdf?.pdffile?.title}}" (contextmenu)="onRightClick($event)" (click)="openLinkById($event)" [innerHTML]="pdf?.linkText"></a>
            </span>
            <span class="answer mr-0-4" *ngFor="let link of statement?.externalLink">
              <a class="external-fasb-link" id="{{baseFasbLink+link?.externalLink}}" (contextmenu)="onRightClick($event)" (click)="openLinkById($event)" [innerHTML]="link?.linkText"></a>
            </span>
            <div class="mt-0-2" [innerHTML]="statement.label4"></div>
            <br>
          </div>
        </div>

        <div class="box"></div>
      </div>
    </div>
  </div>
  <div class="rightfloat float-R">
    <div class="rightfloatBG_padding">
      <div class="answer font-16 content-blue width-100" tabindex="0">
        <p [innerHTML]="archiveLibraryDescription1"></p>
        <p [innerHTML]="archiveLibraryDescription2"></p>
      </div>
      <img src="../../../assets/icons/Downloads.svg" class="download-image" alt="download icon">
      <span class="font-16" id="DownloadLink" role="heading" aria-level="2" tabindex="0">
        <a target="_blank" href="{{adobeDownloadLink}}">{{adobeDownloadText}}</a>
      </span>
    </div>
  </div>
</div>
